import HttpRequest from './core/http_request';

class UploadfileProvider extends HttpRequest {

  uploadFileWaterUsage (data) {
    return this.request('upload', '/public/files/uploadFile/kokwatch/water_usage', data);
  }

  uploadLatlngImage (data) {
    return this.request('upload', '/public/files/latlngimage', data);
  }

  // agra
  uploadFileWaterQuality (data) {
    return this.request('upload', '/public/files/uploadFile/agra/water_quality', data);
  }

  uploadFileSoundMeasurement (data) {
    return this.request('upload', '/public/files/uploadFile/agra/sound_measurement', data);
  }

  uploadFileSoundMeasurementMedia (data) {
    return this.request('upload', '/public/files/uploadFile/agra/sound_measurement_media', data);
  }

  uploadFileEnvHeavyMetalAgra (data) {
    return this.request('upload', '/public/files/uploadFile/agra/env_heavy_metal', data);
  }

  uploadFileScreen (data) {
    return this.request('upload', '/public/files/uploadFile/agra/screen', data);
  }
  // end agra

  // kokwatch
  uploadFileWaterQualityKokwatch (data) {
    return this.request('upload', '/public/files/uploadFile/kokwatch/water_quality', data);
  }

  uploadFileEnvHeavyMetalKokwatch (data) {
    return this.request('upload', '/public/files/uploadFile/kokwatch/env_heavy_metal', data);
  }
  // end kokwatch

  uploadFileEnvHeavyMetal (data) {
    return this.request('upload', '/public/files/uploadFile/questionnaire/env_heavy_metal', data);
  }

  // watersupply
   uploadFileWaterSupply (data) {
    return this.request('upload', '/public/files/uploadFile/watersupply', data);
  }
  // end watersupply
}

export default UploadfileProvider;
